<div [formGroup]="filterForm" class="filters">
  <div *ngIf="fechasEvento$ | async as fechasEvento">
    <mat-form-field appearance="outline" class="full-width filters-x0">
      <mat-label>Fecha de evidencia</mat-label>
      <mat-select [formControl]="fechaForm">
        <mat-option *ngFor="let fecha of fechasEvento" [value]="fecha">
          {{fecha | date}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div *ngIf="materias$ | async as materias">
    <mat-form-field appearance="outline" class="full-width filters-x0">
      <mat-label>Materias</mat-label>
      <mat-select [formControl]="materiaForm">
        <mat-option [value]="0">
          Todas
        </mat-option>
        <mat-option *ngFor="let materia of materias" [value]="materia.id">
          {{materia.nombre}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="full-width filters-x0">
      <mat-label>Estado</mat-label>
      <mat-select formControlName="estado">
        <mat-option *ngFor="let opcion of estado" [value]="opcion.value">
          {{opcion.key}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="full-width filters-x0">
      <mat-label>Progreso de evaluación</mat-label>
      <mat-select formControlName="evaluado">
        <mat-option *ngFor="let opcion of evaluado" [value]="opcion.value">
          {{opcion.key}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-slide-toggle color="primary" [formControl]="mostrarAutoevaluacionForm">Ver autoevaluación</mat-slide-toggle>
  </div>
</div>
<div *ngIf="columnas && columnas.length > 0">
  <div *ngIf="alumnosFilter$ | async as alumnos; else loading" class="feedback-grid-body mat-elevation-z2">
    <table mat-table [dataSource]="alumnosFilter$ | async" style="min-width: 100%;">
      <ng-container matColumnDef="alumnos" sticky>
        <th mat-header-cell *matHeaderCellDef class="students-list">
          <div style="display: flex; flex-wrap: wrap; justify-content: space-between;">
          <mat-checkbox (change)="selectAll($event.checked, alumnos)" style="margin: 0 8px">Alumno</mat-checkbox>
            <button mat-raised-button [matMenuTriggerFor]="menuDevolver" style="margin-right: 8px;">
              Acciones
            </button>
            <mat-menu #menuDevolver="matMenu">
              <button mat-menu-item (click)="classroomAction('seleccionados', 'publicar')">Publicar</button>
              <button mat-menu-item (click)="classroomAction('seleccionados', 'despublicar')">Despublicar</button>
              <button mat-menu-item (click)="classroomAction('seleccionados', 'comentar')">Comentar</button>
              <!-- <button mat-menu-item (click)="classroomAction('seleccionados', 'devolver-sin-evaluacion')">Devolver sin
                evaluación</button> -->
            </mat-menu>
          </div>
        </th>
        <td mat-cell *matCellDef="let element" class="students-list">
          <div class="students-cell">
            <div style="display: flex; align-items: baseline; margin-right: 8px; margin-top: 8px; width: 100%;">
              <app-alumno-checkbox [alumno]="element" [checkForm]="checkForm"></app-alumno-checkbox>
              <app-alumno-chip style="width: 100%;" [image]="false" [view]="0" [persona]="element"
                [acciones]="element.acciones" (accionEvento)="handleAccion($event, element)"></app-alumno-chip>
            </div>
            <!-- <label class="assignment-mark" matBadgeSize="small">
              <mat-icon style="opacity: .32;" class="cursor-pointer" matTooltip="Retroalimentar">spellcheck</mat-icon>
            </label> -->
            <app-retroalimentacion-grid-classroom-estado [submission]="element.submission"
              [devuelto]="element.devuelto">
            </app-retroalimentacion-grid-classroom-estado>
            <label (click)="abrirModalComentario(element)" [matBadge]="element.comentarios>0 ? element.comentarios : ''"
              matBadgeColor="black" matBadgeSize="small" class="assignment-mark" aria-hidden="false">
              <mat-icon *ngIf="element.comentariosNuevos > 0" class="check-mummy cursor-pointer">notifications
              </mat-icon>
              <mat-icon style="opacity: .32;" class="cursor-pointer" matTooltip="Retroalimentación">
                {{element.comentarios > 0 ? 'comment' : 'mode_comment'}}</mat-icon>
            </label>
          </div>
        </td>
      </ng-container>
      <ng-container *ngFor="let criterio of criterios; let i = index"
        [matColumnDef]="criterio.metaData.id.toString()+'-'+criterio.id.toString()">
        <th mat-header-cell *matHeaderCellDef class="criteria-col">
          <span class="criterio-pretitle">
          </span>
          <mat-icon [matTooltip]="criterio.metaData.desc + ' ' + criterio.metaData.id" matTooltipClass="tooltip-meta">
            flag</mat-icon>
          {{criterio.nombre}}
        </th>
        <td mat-cell *matCellDef="let element" class="criteria-col">
          <app-retroalimentacion-criterio-control view="tabla" [criterio]="criterio" [fecha$]="fechaActual$"
            [eventoUnidadID]="eventoUnidadId" [alumno]="element" [alumnos$]="alumnosFilter$"
            [mostrarAutoevaluacion$]="mostrarAutoevaluacion$"></app-retroalimentacion-criterio-control>
        </td>
      </ng-container>
      <ng-container matColumnDef="star">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon>more_vert</mat-icon>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnas; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnas;"></tr>
    </table>
  </div>
</div>
<ng-template #loading>
  <mat-progress-bar mode=indeterminate></mat-progress-bar>
</ng-template>
<!-- </div> -->